module.exports = __webpack_public_path__ + "static/assets/af4b572c05a82c91fabb3c1b6e930398.svg";